module.exports = __webpack_public_path__ + "img/stats-graph.273d078a.jpeg";